export const APARTMENTS = [
	{ name: "–", value: 0 },
	{ name: "Apartament 1", value: 1 },
	{ name: "Apartament 2", value: 2 },
	{ name: "Apartament 3", value: 3 },
	{ name: "Apartament 4", value: 4 },
	{ name: "Apartament 5", value: 5 },
	{ name: "Apartament 6", value: 6 },
	{ name: "Apartament 7", value: 7 },
	{ name: "Apartament 8", value: 8 },
	{ name: "Apartament 9", value: 9 },
	{ name: "Apartament 10", value: 10 },
	{ name: "Apartament 11", value: 11 },
	{ name: "Apartament 12", value: 12 },
	{ name: "Apartament 13", value: 13 },
	{ name: "Apartament 14", value: 14 },
	{ name: "Apartament 15", value: 15 },
	{ name: "Apartament 16", value: 16 },
	{ name: "Apartament 17", value: 17 },
	{ name: "Apartament 18", value: 18 },
	{ name: "Apartament 19", value: 19 },
	{ name: "Apartament 20", value: 20 },
	{ name: "Apartament 21", value: 21 },
	{ name: "Apartament 22", value: 22 },
	{ name: "Apartament 23", value: 23 },
	{ name: "Apartament 24", value: 24 },
	{ name: "Apartament 25", value: 25 },
	{ name: "Apartament 26", value: 26 },
	{ name: "Apartament 27", value: 27 },
	{ name: "Apartament 28", value: 28 },
	{ name: "Apartament 29", value: 29 },
	{ name: "Apartament 30", value: 30 },
];

export const APARTMENT_MAP = Object.fromEntries(
    APARTMENTS.map((a) => [a.value, a.name])
);